import { render, staticRenderFns } from "./verify.component.vue?vue&type=template&id=cdb76ad2&scoped=true"
import script from "./verify.component.vue?vue&type=script&lang=js"
export * from "./verify.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb76ad2",
  null
  
)

export default component.exports